export default "__VITE_ASSET__BBP3_WIh__"